import { Component, computed, inject, signal } from '@angular/core';
import { TooltipDirective } from 'src/app/shared/directives/tooltip/tooltip.directive';
import { DifferenceToolDirective } from './difference.directive';
import { MatMenuModule } from '@angular/material/menu';
import { FormsModule } from '@angular/forms';
import { OverflowPaddingDirective } from 'src/app/shared/directives/overflow-padding.directive';
import { TuiScrollbar } from '@taiga-ui/core';
import { TuiCheckbox, TuiSwitch } from '@taiga-ui/kit';
import { TuiInputModule } from '@taiga-ui/legacy';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'difference-button',
  standalone: true,
  imports: [TooltipDirective, MatMenuModule, FormsModule, OverflowPaddingDirective,     TuiCheckbox,CommonModule,
      TuiScrollbar,
      TuiSwitch,
      TuiInputModule,],
  template: `
  <span   class="flex flex-row items-center border border-gray-400 rounded-lg px-2 shadow-inner shadow-gray-500/30 bg-gray-100">
      <button
      type="button"
      appTooltip="Difference with Layers"
      class="esk-tool"
      [class.esk-tool--active]="isActive()"
      (click)="tool.toggle()"
    >
      <i class="fa fa-cut"></i>
    </button>
    <button
      appTooltip="Difference Targets"

      [matMenuTriggerFor]="menu"
      class="menu-button text-gray-700 hover:text-blue-600 focus:outline-none ml-3"
    >
      <i class="fa fa-chevron-down chevron-icon"></i>
    </button>

  </span>


  <mat-menu class="px-2" #menu="matMenu">
  <div class="grid grid-cols-[1fr_96px] items-center gap-4 py-2.5 font-bold border-b border-gray-300">
    <label class="flex items-center gap-2">
      <input
        tuiCheckbox
        type="checkbox"
        [indeterminate]="tool.indeterminate()"
        [ngModel]="tool.allSelected()"
        (ngModelChange)="tool.toggleSelectAll($event)"
        [ngModelOptions]="{standalone: true}"
        (click)="$event.stopPropagation()"
      />
      Layers
    </label>
    <span class="justify-self-end">Is Land Use</span>
  </div>

  <tui-scrollbar>
    <div overflowPadding class="max-h-[400px]">
      @for(layer of tool.differenceTargets(); track layer.layerID){
        <div class="grid grid-cols-[1fr_96px] items-center gap-4 py-2.5 border-b border-gray-200">
          <label class="flex items-center gap-2 truncate">
            <input
              tuiCheckbox
              type="checkbox"
              [ngModel]="layer.isSelected"
              (ngModelChange)="tool.updateRow(layer.layerID,{isSelected:$event})"
              [ngModelOptions]="{standalone: true}"
              (click)="$event.stopPropagation()"
            />
            {{ layer.name }}
          </label>
          <span
            class="justify-self-end font-medium"
            [ngClass]="layer.isLandUse ? 'text-green-600' : 'text-red-500'"
          >
            {{ layer.isLandUse ? 'Yes' : 'No' }}
          </span>
        </div>
      }
    </div>
  </tui-scrollbar>
</mat-menu>
  `,
})
export class DifferenceButtonComponent {
  readonly tool = inject(DifferenceToolDirective);
  isActive = computed(() => this.tool.active());
}